module.exports = ".lagendStyle\r\n{\r\n    font-size: 13px;\r\n    color: #00bfd6;\r\n    font-weight: bold;\r\n    border-bottom-color: #00bfd6;\r\n}"